import { useState } from "react";
import { useTranslation } from "react-i18next";

import style from "./PathScheduleTestPopup.module.css";
import Modal from "@/ui/modal/Modal";
import Button from "@/ui/button/Button";
import Icon from "@/ui/icon/Icon";

import Calendar from "@/ui/calendar/Calendar";
import PathTestTimePicker from "../pathTestTimePicker/PathTestTimePicker";

function PathScheduleTestPopup() {
	const { t } = useTranslation();
	const [step, setStep] = useState(0);
	const [date, setDate] = useState(new Date());

	const handleNextStep = () => {
		setStep((prevStep) => prevStep + 1);
	};

	return (
		<div className={style.container}>
			<div className={style.header}>
				<div className={style.currentStep}>
					<div className={style.icoHolder}>
						{step === 0 && <Icon icon="fa-calendar" />}
						{step === 1 && <Icon icon="fa-check" />}
					</div>
					<span>{t("paths:scheduleTestPopup.title")}</span>
				</div>
				<div className={style.closeButton}>
					<Modal.Close />
				</div>
			</div>
			<div className={style.body}>
				{step === 0 && (
					<>
						<div>
							<Calendar
								mode="single"
								selected={date}
								onSelect={setDate}
							/>
						</div>
						<div className={style.chooseTime}>
							<PathTestTimePicker />
						</div>
					</>
				)}
				{step === 1 && (
					<div className={style.success}>
						<div className={style.successIcon}>
							<Icon icon="fa-check" />
						</div>
						<h2>{t("paths:scheduleTestPopup.successTitle")}</h2>
						<p>{t("paths:scheduleTestPopup.successText")}</p>
					</div>
				)}
			</div>
			<div className={style.footer}>
				{step < 1 ? (
					<Button
						className={style.btn}
						type="accent"
						onClick={handleNextStep}
					>
						{t("paths:scheduleTestPopup.next")}
					</Button>
				) : null}
			</div>
		</div>
	);
}

export default PathScheduleTestPopup;
